import React from 'react';
import OdfjellInputComponent from 'src/components/common/odfjell-input-component/OdfjellInputComponent';
import { Bunkering } from 'src/types/ViewModel/Bunkering/Bunkering';
import { FuelRobColumn } from 'src/types/ViewModel/Bunkering/FuelRobColumn';
import { Tank } from 'src/types/ViewModel/Vessel/Tank';
import { BunkerChangeInputGrid, HeaderStyle } from './BunkerRob.styles';
import { BunkerLoss } from 'src/types/ViewModel/Bunkering/BunkerLoss';
import { getBunkerLossReasonText, getBunkerLossReasonTexts } from 'src/types/ViewModel/Bunkering/BunkerLossReason';

interface BunkerLossProps {
    column: FuelRobColumn;
    availableBunkerings: Bunkering[];
    allTanks: Tank[];
    tankOptions: Tank[];
    selectedBunkerLoss: BunkerLoss;
    handleSelectBunkering: (changeObject: any) => void;
    handleSelectTank: (changeObject: any) => void;
    handleChangeLoss: (changeObject: any) => void;
    handleChangeLossReason: (changeObject: any) => void;
    handleChangeComment: (changeObject: any) => void;
    validComment: boolean;
}

const BunkerLossEdit: React.FC<BunkerLossProps> = ({
    column,
    availableBunkerings,
    allTanks,
    tankOptions,
    selectedBunkerLoss,
    handleSelectBunkering,
    handleSelectTank,
    handleChangeLoss,
    handleChangeLossReason,
    handleChangeComment,
    validComment,
}) => {
    const GetBunkeringReference = (bunkeringGuid: string) => {
        return availableBunkerings.find((b) => b.bunkeringGuid === bunkeringGuid)?.bunkeringReference;
    };

    const GetTankName = (tankId: number) => {
        return allTanks.find((tank) => tank.tankId === tankId)?.tankName;
    };

    return (
        <>
            <HeaderStyle>{selectedBunkerLoss?.bunkerLossId > 0 ? 'Edit loss:' : 'New loss:'}</HeaderStyle>
            <BunkerChangeInputGrid>
                <div>Select bunkering reference</div>
                <OdfjellInputComponent
                    type="select"
                    options={availableBunkerings.map((b) => b.bunkeringReference)}
                    value={GetBunkeringReference(selectedBunkerLoss?.bunkeringGuid)}
                    onChange={handleSelectBunkering}
                    selectDefaultOption="Select bunkering reference"
                    isReadOnly={selectedBunkerLoss?.bunkerLossId > 0}
                />
                <div>Select tank</div>
                <OdfjellInputComponent
                    type="select"
                    options={tankOptions.map((tank) => tank.tankName)}
                    selectDefaultOption="Select tank"
                    value={GetTankName(selectedBunkerLoss?.tankId)}
                    onChange={handleSelectTank}
                    isReadOnly={!selectedBunkerLoss?.bunkeringGuid || selectedBunkerLoss?.bunkerLossId > 0}
                />
                <div>Reason</div>
                <OdfjellInputComponent
                    type="select"
                    options={getBunkerLossReasonTexts(
                        availableBunkerings.find((b) => b.bunkeringGuid === selectedBunkerLoss?.bunkeringGuid)?.fuelType
                    )}
                    selectDefaultOption="Select reason"
                    isReadOnly={!selectedBunkerLoss?.tankId}
                    value={getBunkerLossReasonText(selectedBunkerLoss?.reason)}
                    onChange={handleChangeLossReason}
                />
                <div>Comment</div>
                <OdfjellInputComponent
                    type="textarea"
                    isReadOnly={!selectedBunkerLoss?.tankId}
                    value={selectedBunkerLoss?.comment}
                    onChange={handleChangeComment}
                    maxTextLength={400}
                    validationInTooltip
                    warningText={validComment ? '' : 'Comment is mandatory when "Other reason" is selected.'}
                />
                <div>Loss</div>
                <OdfjellInputComponent
                    type="number"
                    value={selectedBunkerLoss?.quantityMT}
                    onChange={handleChangeLoss}
                    min={0}
                    max={column.fuelRobs.find((rob) => rob.tankId === selectedBunkerLoss?.tankId)?.rob ?? 0}
                    unit="MT"
                    isReadOnly={!selectedBunkerLoss?.tankId}
                    validationInTooltip
                />
            </BunkerChangeInputGrid>
        </>
    );
};

export default BunkerLossEdit;
